import React, { Component } from 'react';
import './element-matriz-didatica.css';

export default class ElementMatrizDidatica extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: this.props.content
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.content !== prevProps.content) {
      this.setState({ content: this.props.content });
    }
  }

  calculateCargaHoraria(quantidade, fator) {
    return quantidade && fator ? (quantidade * fator).toFixed(2) : '0.00';
  }

  getFont(font) {
    if (font) return font.replace(/\s/g, '-').toLowerCase();
  }

  render() {
    const { headerActionsTemplate, footerActionsTemplate, content, labels } = this.props;
    const matrizLabels = labels && labels.elements && labels.elements.settings && labels.elements.settings.element_matriz_didatica || {};
    const containerStyle = {
      background: content.background_color,
      paddingTop: content.padding_top + "px",
      paddingBottom: content.padding_bottom + "px"
    };

    return (
      <div className={`element-matriz-didatica ${this.getFont(content.font_family) || ""}`} style={containerStyle}>
        {headerActionsTemplate}
        
        <div className="matriz-didatica-card">
          {/* Painel Consolidado */}
          <div className="matriz-didatica-section">
            <h3 className="matriz-didatica-section-title">{matrizLabels.content_label_consolidated_panel || 'Painel Consolidado'}</h3>
            <div className="matriz-didatica-consolidated">
              <div className="matriz-didatica-row">
                <div className="matriz-didatica-field">
                  <label>{matrizLabels.content_label_course || 'Curso:'}</label>
                  <span>{content.curso || '-'}</span>
                </div>
                <div className="matriz-didatica-field">
                  <label>{matrizLabels.content_label_total_hours || 'Carga Horária Total:'}</label>
                  <span>{content.carga_horaria_total || '-'}</span>
                </div>
              </div>
              <div className="matriz-didatica-row">
                <div className="matriz-didatica-field">
                  <label>{matrizLabels.content_label_discipline || 'Disciplina:'}</label>
                  <span>{content.disciplina || '-'}</span>
                </div>
                <div className="matriz-didatica-field">
                  <label>{matrizLabels.content_label_teacher || 'Docente:'}</label>
                  <span>{content.docente || '-'}</span>
                </div>
              </div>
              <div className="matriz-didatica-row">
                <div className="matriz-didatica-field">
                  <label>{matrizLabels.content_label_di_responsible || 'DI Responsável:'}</label>
                  <span>{content.di_responsavel || '-'}</span>
                </div>
              </div>
              <div className="matriz-didatica-row">
                <div className="matriz-didatica-field full-width">
                  <label>{matrizLabels.content_label_syllabus || 'Ementa:'}</label>
                  <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: content.ementa || '-'}}></div>
                </div>
              </div>
              <div className="matriz-didatica-row">
                <div className="matriz-didatica-field full-width">
                  <label>{matrizLabels.content_label_general_objective || 'Objetivo Geral:'}</label>
                  <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: content.objetivo_geral || '-'}}></div>
                </div>
              </div>
            </div>
          </div>

          {/* Lista de Semanas/Módulos */}
          <div className="matriz-didatica-section">
            <h3 className="matriz-didatica-section-title">{matrizLabels.content_label_weeks_modules || 'Semanas/Módulos'}</h3>
            <div className="matriz-didatica-semanas">
              {content.semanas && content.semanas.map((semana, index) => (
                <div key={semana.id} className="matriz-didatica-semana-card">
                  <div className="matriz-didatica-semana-header">
                    <h4>{matrizLabels.content_label_week || 'Semana'} {index + 1}: {semana.titulo || 'Sem título'}</h4>
                  </div>
                  <div className="matriz-didatica-semana-content">
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field">
                        <label>{matrizLabels.content_label_learning_objective || 'Objetivo de Aprendizagem:'}</label>
                        <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: semana.objetivo_aprendizagem || '-'}}></div>
                      </div>
                    </div>
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field">
                        <label>{matrizLabels.content_label_programmatic_content || 'Conteúdo Programático:'}</label>
                        <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: semana.conteudo_programatico || '-'}}></div>
                      </div>
                    </div>
                    <div className="matriz-didatica-materials">
                      <div className="matriz-didatica-material">
                        <h5>{matrizLabels.content_label_basic_material || 'Material Básico'}</h5>
                        <div className="matriz-didatica-material-info">
                          <span><strong>{(matrizLabels.content_label_basic_material_type || 'Tipo:').replace(':', '')}:</strong> {semana.tipo_material_basico || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_basic_material_title || 'Título:').replace(':', '')}:</strong> {semana.titulo_material_basico || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_authorship || 'Autoria:').replace(':', '')}:</strong> {semana.autoria_basico || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_quantity || 'Quantidade:').replace(':', '')}:</strong> {semana.quantidade_basico || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_conversion_factor || 'Fator:').replace(':', '')}:</strong> {semana.fator_basico || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_estimated_hours || 'Carga Horária:').replace(':', '')}:</strong> {this.calculateCargaHoraria(semana.quantidade_basico, semana.fator_basico)}h</span>
                          {semana.link_basico && <span><strong>{(matrizLabels.content_label_link || 'Link:').replace(':', '')}:</strong> <a href={semana.link_basico} target="_blank" rel="noopener noreferrer">{semana.link_basico}</a></span>}
                        </div>
                      </div>
                      <div className="matriz-didatica-material">
                        <h5>{matrizLabels.content_label_support_material || 'Material de Apoio'}</h5>
                        <div className="matriz-didatica-material-info">
                          <span><strong>{(matrizLabels.content_label_support_material_type || 'Tipo:').replace(':', '')}:</strong> {semana.tipo_material_apoio || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_support_material_title || 'Título:').replace(':', '')}:</strong> {semana.titulo_material_apoio || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_authorship || 'Autoria:').replace(':', '')}:</strong> {semana.autoria_apoio || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_quantity || 'Quantidade:').replace(':', '')}:</strong> {semana.quantidade_apoio || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_conversion_factor || 'Fator:').replace(':', '')}:</strong> {semana.fator_apoio || '-'}</span>
                          <span><strong>{(matrizLabels.content_label_estimated_hours || 'Carga Horária:').replace(':', '')}:</strong> {this.calculateCargaHoraria(semana.quantidade_apoio, semana.fator_apoio)}h</span>
                          {semana.link_apoio && <span><strong>{(matrizLabels.content_label_link || 'Link:').replace(':', '')}:</strong> <a href={semana.link_apoio} target="_blank" rel="noopener noreferrer">{semana.link_apoio}</a></span>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Videoaulas Previstas */}
          <div className="matriz-didatica-section">
            <h3 className="matriz-didatica-section-title">{matrizLabels.content_label_videos || 'Videoaulas Previstas'}</h3>
            <div className="matriz-didatica-videoaulas">
              {content.videoaulas && content.videoaulas.map((videoaula, index) => (
                <div key={videoaula.id} className="matriz-didatica-videoaula-card">
                  <div className="matriz-didatica-videoaula-header">
                    <h4>{matrizLabels.content_label_video || 'Videoaula'} {index + 1}</h4>
                  </div>
                  <div className="matriz-didatica-videoaula-content">
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field">
                        <label>{matrizLabels.content_label_video_week || 'Semana:'}</label>
                        <span>{videoaula.semana || '-'}</span>
                      </div>
                      <div className="matriz-didatica-field">
                        <label>{matrizLabels.content_label_sequence || 'Sequência:'}</label>
                        <span>{videoaula.sequencia || '-'}</span>
                      </div>
                    </div>
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field">
                        <label>{matrizLabels.content_label_title || 'Título:'}</label>
                        <span>{videoaula.titulo || '-'}</span>
                      </div>
                      <div className="matriz-didatica-field">
                        <label>{matrizLabels.content_label_format || 'Formato:'}</label>
                        <span>{videoaula.formato || '-'}</span>
                      </div>
                    </div>
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field full-width">
                        <label>{matrizLabels.content_label_objectives || 'Objetivos:'}</label>
                        <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: videoaula.objetivos || '-'}}></div>
                      </div>
                    </div>
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field full-width">
                        <label>{matrizLabels.content_label_details || 'Detalhamento:'}</label>
                        <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: videoaula.detalhamento || '-'}}></div>
                      </div>
                    </div>
                    <div className="matriz-didatica-row">
                      <div className="matriz-didatica-field full-width">
                        <label>{matrizLabels.content_label_references || 'Referências e/ou Sugestões:'}</label>
                        <div className="matriz-didatica-text-content" dangerouslySetInnerHTML={{__html: videoaula.referencias || '-'}}></div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {footerActionsTemplate}
      </div>
    );
  }
}